import config from "./config";
var axios = config();

export default {
  getRequests() {
    return axios.get("/api/OverageRequests");
  }
};
